import React, { Component, Ref } from 'react';
import { ICategory } from 'app/services/category';
import { ILayout } from 'app/services/layout';
import { ProfileImage } from 'app/shared';
import { PublishBar, CategoryBar, ArchiveBar, LayoutBar } from '.';
import ThumbnailBar from './ThumbnailBar';
import QRCode from 'react-qr-code';
import { PrimaryButton } from 'office-ui-fabric-react';
import { getCurrentSiteUi } from 'app/utils/service';

export interface ILayoutBar {
  hide?: boolean;
  layout?: string;
  onChangeLayout?: (layout: string) => void;
  layoutData?: ILayout[];
}

export interface IThumbnailBar {
  hide?: boolean;
  thumbnail?: ProfileImage;
  onSave?: (data: ProfileImage) => void;
  onClickThumbnail?: () => void;
  onDeleteThumbnail?: () => void;
}

export interface IPublishBar {
  hide?: boolean;
  onSave?: (isDraft?: boolean) => void;
  onClickPreview?: () => void;
  onDelete?: () => void;
  showOrder?: boolean;
  order?: number;
  onChangeOrderIndex?: (order: number) => void;
  showDateOrder?: boolean;
  dateOrder?: number;
  onChangeDateOrderIndex?: (order: number) => void;
  disabledSaveButton?: boolean;
  hideDeleteButton?: boolean;
  hidePreviewButton?: boolean;
  hideDraftButton?: boolean;
  statusText?: string;
  buttonText?: string;
  userLabel?: string;
  dateText?: string;
  publishDateText?: string;
  isEdit?: boolean;
  userName?: string;
  status?: number;
  showIntegration?: boolean;
  integrationId?: string;
  onChangeIntegrationId?: (value: string) => void;
}

export interface IArchiveBar {
  hide?: boolean;
}

export interface ICategoryBar {
  hide?: boolean;
  categories?: ICategory[];
  value?: string;
  onChangeCategory?: (category: string | null) => void;
  onToggleModal?: () => void;
}

export interface ISidebar {
  publishBar?: IPublishBar;
  layoutBar?: ILayoutBar;
  thumbnailBar?: IThumbnailBar;
  archiveBar?: ILayoutBar;
  categoryBar?: ICategoryBar;
  url?: string;
}

export default class Sidebar extends Component<ISidebar> {
  qrRef: Ref<HTMLDivElement>;
  constructor(props: ISidebar) {
    super(props);
    this.qrRef = React.createRef();
  }

  handleDowlnadQR = () => {
    if (!this.qrRef) return;

    //@ts-ignore
    const ref = this.qrRef.current;
    if (ref) {
      const svg = ref.querySelector('svg') as SVGAElement;

      if (svg) {
        var serializedSVG = new XMLSerializer().serializeToString(svg);
        const anchor = document.createElement('a');
        anchor.href = 'data:image/svg+xml;base64,' + btoa(serializedSVG);
        anchor.download = `${this.props.url}.svg`;
        anchor.click();
      }
    }
  };

  render() {
    return (
      <aside className="page-sidebar">
        <PublishBar {...(this.props.publishBar as IPublishBar)} />
        {!this.props.categoryBar?.hide && (
          <CategoryBar {...(this.props.categoryBar as ICategoryBar)} />
        )}
        {!this.props.archiveBar?.hide && (
          <ArchiveBar {...(this.props.archiveBar as IArchiveBar)} />
        )}
        {!this.props.layoutBar?.hide && (
          <LayoutBar {...(this.props.layoutBar as ILayoutBar)} />
        )}
        {!this.props.thumbnailBar?.hide && (
          <ThumbnailBar {...(this.props.thumbnailBar as IThumbnailBar)} />
        )}
        {this.props.children}
        {this.props.url && (
          <div
            ref={this.qrRef}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <QRCode value={getCurrentSiteUi() + '/' + this.props.url} />
            <PrimaryButton onClick={this.handleDowlnadQR}>
              QR Code İndir
            </PrimaryButton>
          </div>
        )}
      </aside>
    );
  }
}
